import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ContactList } from '../../../contacts/contact-list.model';
import { HttpRepositoryService } from '../../../core/http-repository.service';
import { CustomFieldJSON } from '../../../contacts/contact-list-assign/contact-list-assign.component';
import * as XLSX from 'xlsx';
import { SubSink } from 'subsink';
import { UserCompanyService } from '../../../nav-menu/user-company.service';

declare var $: any;

@Component({
  selector: 'upload-file-select-contactlist',
  templateUrl: './upload-file-select-contactlist.component.html',
  styleUrls: ['./upload-file-select-contactlist.component.css']
})

export class UploadFileSelectContactlistComponent implements OnInit, OnDestroy {

  private sheetTable: object[] = [];
  private tableHeader: string[] = [];
  private dataTable: any;
  private dtTable: any;
  private dtOptions: any;
  private idContactList: number;
  private defaultOptionInDropDown: boolean = false;
  private customFieldBySelectedContactList: CustomFieldJSON[] = [];
  private customFieldName: string[] = [];
  private requiredContactFields = ['Email', 'Phone'];
  private isUploaded: boolean = false;
  private fileName: string;
  private selectedCompany: number;
  private selectCompanyHtmlElement: any;
  private subs = new SubSink();

  @Input()
  private contactList: ContactList[] = [];

  @Output()
  private loadedSheetTable: EventEmitter<UploadedTable> = new EventEmitter<UploadedTable>();

  @Output()
  private selectedContactList: EventEmitter<SelectedContactList> = new EventEmitter<SelectedContactList>();

  @Output()
  private resetTable: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private repository: HttpRepositoryService, private companyService: UserCompanyService) { }

  ngOnInit() {
    this.defaultOptionInDropDown = true;
    this.selectCompanyHtmlElement = $('#selectCompanyDropdown');
    this.dataTable = $('#importFiles');
    this.createTable();
  }

  private onChange(event) {
    this.idContactList = parseInt(event.target.value);
    this.defaultOptionInDropDown = false;

    this.subs.sink = this.companyService.currentSelectedCompany.subscribe(cmpRes => {
      this.selectedCompany = cmpRes;

      this.subs.sink = this.repository.get<any>('api/ContactList/Details/' + this.idContactList + '?companyId=' + this.selectedCompany).subscribe(resp => {
        this.customFieldBySelectedContactList = resp.data.customFields;
        this.customFieldName = this.customFieldBySelectedContactList.map(x => x.name);
        this.customFieldName.unshift(...this.requiredContactFields);
        this.onSelectedContactList();
      });
    });
  }

  upload(event: any) {
    this.tableHeader = [];
    const target: DataTransfer = <DataTransfer>(event.target);
    const reader = new FileReader();
    let that = this;

    reader.onload = function (e: any) {
      const bstr: string = e.target.result;
      const workbook = XLSX.read(bstr, { type: "binary", cellDates: true, cellNF: false, cellText: false });
      const wsname: string = workbook.SheetNames[0];
      const sheet = workbook.Sheets[wsname];
      const firstRow = sheet[XLSX.utils.encode_cell({ r: 0, c: 0 })];

      if (target.files[0])
        that.fileName = target.files[0].name;

      if (firstRow.v == 'export results') {
        that.sheetTable = XLSX.utils.sheet_to_json(sheet, { raw: false, range: 1, blankrows: false, defval: null, dateNF: 'DD-MM-YYYY' });
      } else {
        that.sheetTable = XLSX.utils.sheet_to_json(sheet, { raw: false, blankrows: false, defval: null, dateNF: 'DD-MM-YYYY' });
      }

      if (that.sheetTable[0]) {
        that.tableHeader = Object.keys(that.sheetTable[0]).map(x => x);
        that.isUploaded = true;
        that.selectCompanyHtmlElement.addClass('disabled');
      }

      that.createTable();
      that.onLoadedTableSheet();
    }

    if (target.files[0])
      reader.readAsBinaryString(target.files[0]);
  }

  private createTable() {
    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }

    this.dtOptions = {
      data: this.sheetTable,
      columns: this.tableHeader.map(x => ({ name: x })),
      index: false,
      select: false,
      filter: false,
      orderBy: false,
      exportButtons: [],
      autoColumnTitle: true
    }

    this.dtTable = this.dataTable.LinkTable(this.dtOptions);
  }

  public onLoadedTableSheet() {
    let uploadedTable = new UploadedTable();
    uploadedTable.sheetTable = this.sheetTable;
    uploadedTable.tableHeader = this.tableHeader;
    this.loadedSheetTable.emit(uploadedTable);
  }

  private onSelectedContactList() {
    let selectedContactList = new SelectedContactList();
    selectedContactList.idContactList = this.idContactList;
    selectedContactList.customFieldName = this.customFieldName;
    selectedContactList.customFieldBySelectedContactList = this.customFieldBySelectedContactList;
    this.selectedContactList.emit(selectedContactList);
  }

  onResetTable() {
    this.resetTable.emit(true);
  }

  private reset() {
    this.defaultOptionInDropDown = true;
    this.dtTable.Destroy();
    this.fileName = '';
    this.dtTable = null;
    this.sheetTable = [];
    this.tableHeader = [];
    this.isUploaded = false;
    this.selectCompanyHtmlElement.removeClass('disabled');
    this.selectedCompany = 0;
    this.createTable();
    this.onResetTable();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();

    if (this.selectCompanyHtmlElement.hasClass('disabled')) {
      this.selectCompanyHtmlElement.removeClass('disabled');
    }
  }
}

export class UploadedTable {
  sheetTable: object[];
  tableHeader: string[];
}

export class SelectedContactList {
  idContactList: number;
  customFieldName: string[];
  customFieldBySelectedContactList: CustomFieldJSON[];
}
